import ListStatusView from './ComponentView';
import useListStatusTranslations from './hooks/useListStatus.translation';
import useListStatusViewModel from './hooks/useListStatus.viewModel';
import PropTypes from 'prop-types';

const ListStatus = ({ statuses, expanded }) => {
  const translations = useListStatusTranslations();
  const viewModel = useListStatusViewModel({ statuses, expanded });
  return <ListStatusView viewModel={viewModel} translations={translations} />;
};

ListStatus.propTypes = {
  statuses: PropTypes.array.isRequired,
  expanded: PropTypes.bool,
};

ListStatus.propTypes = {
  expanded: false,
};

export default ListStatus;
